import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord } from '@/app/guards';
import { BankPage, bankQuery } from '@/features/banks-products';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/banks/$bankId/')({
  loader: async ({ context, params }) => {
    const bank = await ensureRecord(context.queryClient.query({ ...bankQuery(params.bankId), staleTime: 'static' }));
    return { crumb: bank.name };
  },
  notFoundComponent: function BankNotFound() {
    const { bankId } = Route.useParams();
    return <NotFoundView reference={bankId} />;
  },
  component: function Bank() {
    const { bankId } = Route.useParams();
    return <BankPage bankId={bankId} />;
  },
});
